import settings from "./settings.json";
import appearance from "./appearance.json";
import voice_assistants from "./voice-assistants.json";
import help_center from "./help-center.json";
import profile from "./profile.json";
import cache from "./cache.json";
import notifications from "./notifications.json";
import transactions from "./transactions.json";
import recurring_transactions from "./recurring-transactions.json";
import contacts from "./contacts.json";
import stats from "./stats.json";
import files from "./files.json";
import transaction from "./transaction.json";
import login from "./login.json";
import register from "./register.json";
import password_recovery from "./password-recovery.json";
import payment_methods from "./payment-methods.json";
import account from "./account.json";
import accounts from "./accounts.json";
import category from "./category.json";
import sources from "./sources.json";
import source from "./source.json";
import categories from "./categories.json";
import not_found_404 from "./404.json";
import notes from "./notes.json";
import note from "./note.json";
import home from "./home.json";
import auto_menu from "../../../auto/locales/pt/pages/menu.json";
import auto_transactions from "../../../auto/locales/pt/pages/transactions.json";
import auto_accounts from "../../../auto/locales/pt/pages/accounts.json";
import auto_language from "../../../auto/locales/pt/pages/language.json";
import auto_logout from "../../../auto/locales/pt/pages/logout.json";
import auto_exit from "../../../auto/locales/pt/pages/exit.json";

export default {
  settings,
  appearance,
  voice_assistants,
  help_center,
  profile,
  cache,
  notifications,
  transactions,
  recurring_transactions,
  contacts,
  stats,
  files,
  transaction,
  login,
  register,
  password_recovery,
  payment_methods,
  account,
  accounts,
  sources,
  source,
  categories,
  category,
  not_found_404,
  notes,
  note,
  home,
  auto_menu,
  auto_transactions,
  auto_accounts,
  auto_language,
  auto_logout,
  auto_exit,
};
